var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaretUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 4,
    viewBox: "0 0 7 4",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.42418 2.36034e-05C3.35984 -0.00034833 3.29606 0.0119836 3.23649 0.0363128C3.17693 0.0606418 3.12275 0.096489 3.07707 0.141799L0.143776 3.0751C0.0517179 3.16715 0 3.29201 0 3.4222C0 3.55239 0.0517179 3.67725 0.143776 3.76931C0.235835 3.86137 0.360693 3.91309 0.490883 3.91309C0.621073 3.91309 0.745931 3.86137 0.83799 3.76931L3.42418 1.17823L6.01037 3.76442C6.10389 3.84451 6.2242 3.88636 6.34724 3.88161C6.47028 3.87686 6.58699 3.82585 6.67406 3.73879C6.76113 3.65172 6.81213 3.535 6.81688 3.41196C6.82164 3.28892 6.77979 3.16862 6.69969 3.0751L3.7664 0.141799C3.67534 0.051481 3.55243 0.000563622 3.42418 2.36034e-05Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaretUp);
export default __webpack_public_path__ + "static/media/caret-up.91506d16c554a00aaae3a7a6d0e3595f.svg";
export { ForwardRef as ReactComponent };